export default {

  setTransportList(state, data) {
    state.transportList = data;
  },
  setTransportDetails(state, data) {
    state.transportDetails = data;
  },

  setGifts(state, data) {
    state.gifts = data;
  },
  setFoodList(state, data) {
    state.foodList = data;
  },
  setCalendarList(state, data) {
    state.calendarList = data;
  },

};
